import { render, staticRenderFns } from "./Promos.vue?vue&type=template&id=789ceb67"
import script from "./Promos.vue?vue&type=script&lang=ts"
export * from "./Promos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports